/** The words the filter bar and its drawer share, from the prototype's filter bar. */
export const FILTER_COPY = {
    label: 'Filters',
    none: 'Currently no active filters',
    active: (n: number) => `${n} active`,
    select: 'Select filter',
    remove: (label: string) => `Remove filter ${label}`,
    drawerTitle: 'Filters',
    apply: 'Apply filters',
    clear: 'Clear all',
    /** What a date field says before anything is picked. */
    anyDate: 'Any date',
    anyDates: 'Any dates',
} as const;
